export default __webpack_public_path__ + "static/media/shake4.8a42c24a.jpg";